import { proxy } from 'valtio';
import { computed } from 'valtio-reactive';

import { SavedItem, SavedItemType } from 'models';
import { CollectionHelpers } from 'src/helpers/CollectionHelpers';

type SavedItemsState = { savedItems: SavedItem[]; initialized: boolean };

const savedItemsState = proxy<SavedItemsState>({
    savedItems: [],
    initialized: false,
});

const savedItemsDerivedState = computed({
    lookup: () => {
        const savedItems = savedItemsState.savedItems;

        const lookup: {
            [itemId: string]: string;
        } = {};

        savedItems.forEach((savedItem) => {
            const id = CollectionHelpers.id(savedItem.item.value);

            if (id) {
                lookup[id] = savedItem.id;
            }
        });

        return lookup;
    },
    profiles: () => {
        const savedItems = savedItemsState.savedItems;

        return savedItems.filter((savedItem) => savedItem.item.relationTo === SavedItemType.PROFILE);
    },
    designs: () => {
        const savedItems = savedItemsState.savedItems;

        return savedItems.filter((savedItem) => savedItem.item.relationTo === SavedItemType.PROJECT);
    },
    components: () => {
        const savedItems = savedItemsState.savedItems;

        return savedItems.filter((savedItem) => savedItem.item.relationTo === SavedItemType.COMPONENT);
    },
    collateral: () => {
        const savedItems = savedItemsState.savedItems;

        return savedItems.filter((savedItem) => savedItem.item.relationTo === SavedItemType.COLLATERAL);
    },
});

export { savedItemsState, savedItemsDerivedState };
